// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { FRAGMENT_MONEDA } from '../interfaces/fragment'
import { MonedaApiInputProps, MonedaProps } from '../../../interfaces/monedaPrecio.ts'

const query = gql`
  ${FRAGMENT_MONEDA}
  mutation REGISTRO($input: MonedaRegistroInput!) {
    monedaRegistroV2(input: $input) {
      ...fields
    }
  }
`

/**
 * Registro de moneda
 * @param input
 */
export const apiMonedaRegistro = async (
  input: MonedaApiInputProps,
): Promise<MonedaProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { input })
    return data.monedaRegistroV2
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
